import { TypographyMetricTableLegacy } from '@af/design-system-docs-ui';
import * as React from 'react';
export default {
  TypographyMetricTableLegacy,
  React
};